import { gql } from "@apollo/client";
import { messageHeaders } from "features/common/fragments";
import { comment } from "features/insuranceDocument/queries/fragments";

export const COMMENT_DELETED = gql`
  subscription commentDeleted {
    commentDeleted {
      documentId
      documentCommentId
      headers {
        ...messageHeaders
      }
    }
  }
  ${messageHeaders}
`;

export const COMMENT_ADDED = gql`
  subscription commentAdded {
    commentAdded {
      commentData {
        documentId
        documentStateId
        documentStateName
        comments {
          ...comment
        }
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${comment}
  ${messageHeaders}
`;
